import { useLocation } from 'react-router-dom';
import routes from '@common/routes/index';

/**
 * Returns whether the Marketplace modal is currently visible.
 * This checks the URL query produced by routes.marketplace.getMarketplaceRoute(),
 * avoiding hardcoded parameter names.
 *
 * @returns true when the Marketplace modal should be visible, false otherwise
 */
const useIsMarketplaceVisible = (): boolean => {
  const { search } = useLocation();
  const marketplaceQuery = routes.marketplace.getMarketplaceRoute(); // e.g., '?marketplace=true'
  return search.includes(marketplaceQuery);
};

export default useIsMarketplaceVisible;


